/* eslint-disable */

// import { authHeader } from '../_helpers'
import axios from 'axios'
import { API_ROOT } from '../config'
import api from '../_api'

export const userService = {
  tokenlogin(token) {
    return axios.post(`${API_ROOT}/authenticate`, { token })
  },
  login(username, password) {
    return axios.post(`${API_ROOT}/auth/login`, { password, username })
  },
  sociallogin(backend, code) {
    return axios.post(`${API_ROOT}/social/login`, { backend, code })
  },
  salesforcelogin(instance_url, access_token) {
    return axios.post(`${API_ROOT}/salesforce/login`, { instance_url, access_token })
  },
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user')
    localStorage.removeItem('superuser')
    localStorage.clear()
  },
  refresh() {
    return api.get(`${API_ROOT}/authenticate`)
  },
  passwordReset(email) {
    return axios.post(`${API_ROOT}/password-reset/`,
      { email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      })
  },
  passwordResetConfirm(uid, token, new_password1, new_password2) {
    return axios.post(`${API_ROOT}/password-reset-confirm/${uid}/${token}/`,
      {
        new_password1,
        new_password2,
        uid,
        token,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      })
  },
  getUserTokenById(id) {
    return api.get(`${API_ROOT}/retrieve/${id}/token/`);
  },
  getBurberryLoginLink() {
    return api.get(`${API_ROOT}/burberry_login_link`, { callback: `${window.location.origin}/burberry/callback` });
  }
}
